export const blur = '4px';
